import script from "./JobResizeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobResizeModal.vue?vue&type=script&setup=true&lang=ts"

import "./JobResizeModal.vue?vue&type=style&index=0&id=1e9c3f95&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9c3f95"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
